import { parseDOM } from 'htmlparser2';

const regex = /&\S+;/g;

const hasHtmlEntities = label => {
	if (label && label.length > 0) {
		return regex.test(label);
	}
	return false;
};

const convertLabelCharacters = label => {
	if (hasHtmlEntities(label)) {
		const [el] = parseDOM(`${label}`, { decodeEntities: true });
		return el.data || label;
	}
	return label;
};

export default convertLabelCharacters;



// WEBPACK FOOTER //
// ./src/utils/labels.js